import React, {Component} from "react";
import {connect} from "react-redux";
import axios from "axios";
//components
import Menu from "./components/Menu";
import Header from "./components/Header";
import Body from "./components/Body";
import Input from "./components/Input";
import ConnectedSocket from "./components/connectedSocket";
import NotSupportedBrowser from "./components/notSupportedBrowser";
import debounce from "lodash/debounce";
import elementResizeEvent from "element-resize-event";
//actions
import {
    onToggleWidget,
    onSend,
    onSetHistory,
    onChangeResizeCarousel,
} from "./redux/actions"

class Container extends Component {
    state = {
        carouselLength: 0,
        pos: {
            x: document.documentElement.clientWidth - 480,
            y: window.innerHeight - 480
        },
    };

    async componentDidMount() {
        if (this.props.isConnected === false) {
            let {history, session} = await this.createSession();

            await this.props.onSetHistory(history);
            await this.props.socketInit(session);
            await this.updateLanguage(session);
            await this.props.pushSessionToParentComponent(session);
        }

        await this.props.handlerUpdateCounterHistoryMessage();
        await elementResizeEvent(this.chatContainer, debounce(this.onResizeApp, 200));
    }

    updateLanguage = session => {
        let chatLanguage = document.getElementById('chatLanguage');
        let lang = chatLanguage.getAttribute('data-language');
        let resLang = this.setUpdatedLanguage(lang);
        let options = {
            headers: {'Content-Type': 'text/plain'},
            url: `${window.DOMAIN_NAME}/WebConnector/account/${window.ACCOUNT_ID}/session/${session}/language`,
            method: 'put',
            data: resLang,
        };

        axios({...options, withCredentials: false});
    };

    setUpdatedLanguage = lang => {
        switch (lang.toLowerCase()) {
            case 'uk' :
            case 'ua' :
            case 'ukr' :
                return 'ukr';
            case 'uz':
            case 'uzb':
                return 'uzb';
            case 'ru' :
            case 'rus' :
                return 'rus';
            case 'en' :
            case 'eng' :
                return 'eng';
            default:
                return 'ukr';
        }
    };

    createSession = () => {
        const webSession = window.localStorage.getItem('Web-Session');

        if (!webSession) {
            return axios({
                withCredentials: false,
                method: 'get',
                url: `${window.DOMAIN_NAME}/WebConnector/account/${window.ACCOUNT_ID}/session`
            }, {}).then(response => {
                this.setState({session: response.data.session});
                window.localStorage.setItem('Web-Session', response.data.session)

                return response.data
            });
        } else {
            return axios({
                headers: {
                    "Web-Session": window.localStorage.getItem('Web-Session') || null
                },
                withCredentials: false,
                method: 'get',
                url: `${window.DOMAIN_NAME}/WebConnector/account/${window.ACCOUNT_ID}/session`
            }, {}).then(response => {
                this.setState({session: response.data.session});
                window.localStorage.setItem('Web-Session', response.data.session)

                return response.data
            });
        }
    }

    // Dragging div by id 'Chat'
    componentDidUpdate(props, state) {
        if (this.state.dragging && !state.dragging) {
            document.addEventListener('mousemove', this.onMouseMove);
            document.addEventListener('mouseup', this.onMouseUp);
        } else if (!this.state.dragging && state.dragging) {
            document.removeEventListener('mousemove', this.onMouseMove);
            document.removeEventListener('mouseup', this.onMouseUp);
        }
    }

    onMouseDown = e => {
        if (e.button !== 0) return;

        let pos = document.getElementById("chatContainer");

        this.setState({
            dragging: true,
            rel: {
                x: e.pageX - pos.offsetLeft,
                y: e.pageY - pos.offsetTop
            }
        });
        e.stopPropagation();
        e.preventDefault();
    };

    onMouseUp = e => {
        let chatContainer = this.chatContainer.getBoundingClientRect();
        let windowWidth = window.innerWidth;
        let windowHeight = window.innerHeight;

        this.setState({dragging: false});

        // LEFT
        if (chatContainer && chatContainer.x < 0) {
            this.setState({
                pos: {x: 5}
            });
        }
        // RIGHT
        if (chatContainer && chatContainer.right > windowWidth) {
            let positionLeft = windowWidth - this.chatContainer.offsetWidth - 5;
            this.setState({
                pos: {x: positionLeft}
            });
        }
        // TOP
        if (chatContainer && chatContainer.y < 0) {
            this.setState({
                pos: {y: 5}
            });
        }
        // BOTTOM
        if (chatContainer && chatContainer.bottom > windowHeight) {
            let positionBottom = windowHeight - this.chatContainer.offsetHeight - 5;
            this.setState({
                pos: {y: positionBottom}
            });
        }

        e.stopPropagation();
        e.preventDefault();
    };

    onMouseMove = e => {
        if (!this.state.dragging) return;

        this.setState({
            pos: {
                x: e.pageX - this.state.rel.x,
                y: e.pageY - this.state.rel.y
            }
        });
        e.stopPropagation();
        e.preventDefault();
    };
    // END Dragging div by id 'Chat'

    onResizeApp = () => {
        let chatContainer = this.chatContainer;
        let chatContainerPos = this.chatContainer.getBoundingClientRect();
        let windowWidth = window.innerWidth;
        let windowHeight = window.innerHeight;

        if (chatContainer.offsetWidth < 260) {
            chatContainer.style.width = '350px'
        }

        if (chatContainer.offsetHeight < 350) {
            chatContainer.style.height = '400px'
        }

        // LEFT
        if (chatContainerPos && chatContainerPos.x < 0) {
            this.setState({
                pos: {x: 5}
            });
        }
        // RIGHT
        if (chatContainerPos && chatContainerPos.right > windowWidth) {
            let positionLeft = windowWidth - this.chatContainer.offsetWidth - 5;
            this.setState({
                pos: {x: positionLeft}
            });
        }
        // TOP
        if (chatContainerPos && chatContainerPos.y < 0) {
            this.setState({
                pos: {y: 5}
            });
        }
        // BOTTOM
        if (chatContainerPos && chatContainerPos.bottom > windowHeight) {
            let positionBottom = windowHeight - this.chatContainer.offsetHeight - 5;
            this.setState({
                pos: {y: positionBottom}
            });
        }

        if (chatContainerPos && chatContainerPos.width > (windowWidth / 2)) {
            chatContainer.style.width = `${windowWidth / 2}px`;
        }

        if (chatContainerPos && chatContainerPos.height > (windowHeight / 1.2)) {
            chatContainer.style.height = `${windowHeight / 1.2}px`;
        }

        if (chatContainer.offsetWidth >= 500) {
            if (this.state.carouselLength > 2) {
                this.props.onChangeResizeCarousel(3);
            } else {
                this.props.onChangeResizeCarousel(2);
            }
        } else {
            this.props.onChangeResizeCarousel(2);
        }
    };

    handlerCarouselLength = carouselLength => this.setState({carouselLength});

    handleShowDropZone = () => this.inputType.click();

    handlerOnMessage = data => {
        if (this.props.sendParamsAfterFinishConversation) {
            let chatParams = document.getElementById('chatParams');
            let language = document.getElementById('chatLanguage');
            let lang = language.getAttribute('data-language');
            let newParams = chatParams.getAttribute('data-params');

            this.props.onSendParamsAfterFinishConversation(false);
            this.props.sendParams(newParams, lang, this.props.sessionParentComponent)
            this.props.onSend(data.payload);
            this.props.socket.send(`/connector/message/account/${window.ACCOUNT_ID}/session/${this.props.sessionParentComponent}`, {}, JSON.stringify(data.message));
        } else {
            this.props.onSend(data.payload);
            this.props.socket.send(`/connector/message/account/${window.ACCOUNT_ID}/session/${this.props.sessionParentComponent}`, {}, JSON.stringify(data.message));
        }
    };

    render() {
        let {
            locale,
            isOpen,
            handleVisibleChat,
            handlerMuteNotification,
            muteNotification,
            history,
            config,
            fontSize,
            handleShowEmoji,
            previewFile,
            handleChangeFile,
            handleChangeFontSize,
            session,
            previewFileName,
            visibleEmojiBlock,
            handlerSendFile,
            handlerVisiblePreview,
            onVisiblePreviewFile,
            isMenuReceiver,
            handleChangeHeightWithMenu,
            heightMenu,
            handlerHeaderCloseChat,
            mobilePhone,
            sessionParentComponent,
        } = this.props;

        let lastElem = history.data && history.data[history.data.length - 1];
        let access = lastElem && lastElem.receiver && lastElem.receiver.type === "KEYBOARD";

        return (
            <div id="chatContainer"
                 className={`chat__container ${access ? 'with-menu' : ''} ${this.props.notSupportedBrowser ? 'sm-chat-container__no-scroll' : ''}`}
                 style={{right: '20px', bottom: '20px'}}
                 ref={node => (this.chatContainer = node)}
            >
                <Header onToggleWidget={this.props.onToggleWidget}
                        isOpen={isOpen}
                        onMouseDown={this.onMouseDown}
                        handleVisibleChat={handleVisibleChat}
                        locale={locale}
                        handlerMuteNotification={handlerMuteNotification}
                        muteNotification={muteNotification}
                        access={access}
                        handlerHeaderCloseChat={handlerHeaderCloseChat}
                />

                {!this.props.isConnected && <ConnectedSocket
                    locale={locale}
                    createSession={this.createSession}
                    onSetHistory={this.props.onSetHistory}
                    socketInit={this.props.socketInit}
                    updateLanguage={this.updateLanguage}
                    pushSessionToParentComponent={this.props.pushSessionToParentComponent}
                    isConnected={this.props.isConnected}
                    handlerUpdateCounterHistoryMessage={this.props.handlerUpdateCounterHistoryMessage}
                />}

                {this.props.notSupportedBrowser && <NotSupportedBrowser locale={locale}/>}

                <Body history={history}
                      config={config}
                      onMessage={this.handlerOnMessage}
                      locale={locale}
                      fontSize={fontSize}
                      handleShowEmoji={handleShowEmoji}
                      access={access}
                      previewFileName={previewFileName}
                      isMenuReceiver={isMenuReceiver}
                      heightMenu={heightMenu}
                      handlerCarouselLength={this.handlerCarouselLength}
                />

                <input onChange={(e) => handleChangeFile(e, this.inputType)}
                       type='file'
                       multiple
                       name="inputFile"
                       ref={node => (this.inputType = node)}
                       className="sm-input__drop-zone"
                       id="inputFile"
                />

                <Input onMessage={this.handlerOnMessage}
                       locale={locale}
                       handleShowDropZone={this.handleShowDropZone}
                       handleChangeFontSize={handleChangeFontSize}
                       previewFile={previewFile}
                       session={session}
                       sessionParentComponent={sessionParentComponent}
                       history={history}
                       fontSize={fontSize}
                       previewFileName={previewFileName}
                       visibleEmojiBlock={visibleEmojiBlock}
                       handleShowEmoji={handleShowEmoji}
                       handlerSendFile={handlerSendFile}
                       access={access}
                       handlerVisiblePreview={handlerVisiblePreview}
                       onVisiblePreviewFile={onVisiblePreviewFile}
                       handleChangeFile={handleChangeFile}
                       mobilePhone={mobilePhone}
                />

                <Menu handlerOnMessage={this.handlerOnMessage}
                      access={access}
                      lastElem={lastElem}
                      history={history}
                      config={config}
                      isMenuReceiver={isMenuReceiver}
                      handleChangeHeightWithMenu={handleChangeHeightWithMenu}
                />
            </div>
        )
    }
}

const mapStateToProps = state => ({
    isOpen: state.config.isOpen,
    history: state.history,
    config: state.config,
});

const mapDispatchers = {
    onToggleWidget,
    onSend,
    onSetHistory,
    onChangeResizeCarousel,
};

export default connect(mapStateToProps, mapDispatchers)(Container);



// WEBPACK FOOTER //
// ./src/Container.js